<template>
  <div class="page-padding">
      <RunGroupRepo />
  </div>
</template>

<script setup lang="ts">
import RunGroupRepo from "@/tea/components/rungroups/RunGroupRepo.vue";
</script>
